import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { MouseEventHandler, ReactNode } from 'react';
import type { PopperData } from '..';

export interface ActionsPopperItem {
  onClick?: MouseEventHandler;
  iconName?: IconProp;
  iconElement?: ReactNode;
  label?: ReactNode;
}

export interface ActionsPopperData {
  items: ActionsPopperItem[];
  popper: PopperData;
}

export interface ActionsPopperProps extends ActionsPopperData {}
